import { render, staticRenderFns } from "./ProjectTechnologyEvidencesPage.vue?vue&type=template&id=8b1716ee&scoped=true&"
import script from "./ProjectTechnologyEvidencesPage.vue?vue&type=script&lang=js&"
export * from "./ProjectTechnologyEvidencesPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTechnologyEvidencesPage.vue?vue&type=style&index=0&id=8b1716ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1716ee",
  null
  
)

export default component.exports